import storage from 'local-storage-fallback';

import { LS_ENDORSELY_AFFILIATE_REF_KEY } from './constants';
const REF_ID_MAX_AGE = 1000 * 60 * 60 * 24 * 30; // 30 days

declare global {
  interface Window {
    endorsely_referral?: string;
  }
}

export interface RefIdStorageItem {
  at?: string;
  refId?: string;
}

export function storeAffiliateIds() {
  const referralId = window.endorsely_referral;

  const affiliateRef = getAffiliateRef();
  
  // First-click attribution
  if (affiliateRef) {
    if (import.meta.env.DEV) console.log(`[DEV] Current referral ID ${affiliateRef.refId} is active, skipping`);
    return;
  }

  if (referralId) {
    const item: RefIdStorageItem = {
      at: Date.now().toString(),
      refId: referralId
    };

    storage.setItem(LS_ENDORSELY_AFFILIATE_REF_KEY, JSON.stringify(item));
  }
}

export function getAffiliateRef() {
  let currentRefIdItem: RefIdStorageItem = {};

  try {
    currentRefIdItem = JSON.parse(storage.getItem(LS_ENDORSELY_AFFILIATE_REF_KEY) || '{}') as RefIdStorageItem;
  } catch (_) {
    // ignore
  }

  const isActiveRefId = currentRefIdItem.refId && new Date(currentRefIdItem.at || 0).getTime() > (Date.now() - REF_ID_MAX_AGE);

  if (isActiveRefId) {
    return currentRefIdItem;
  }

  return null;
}